import { AhPlusModal } from "modules/storyblok/components";
import type { AhPlusModalProps } from "modules/storyblok/components/AhPlusModal";
import type { ReactStoryblokComponent } from "types/storyblok";

export const AhPlusModalAdapter = ({
  blok: { ahPlusPricingPlans, heading, review, reviewer, linkText },
  sbEditable,
}: ReactStoryblokComponent<AhPlusModalProps>) => (
  <AhPlusModal
    ahPlusPricingPlans={ahPlusPricingPlans}
    heading={heading}
    linkText={linkText}
    review={review}
    reviewer={reviewer}
    sbEditable={sbEditable}
  />
);
